import React, { ReactEventHandler, SyntheticEvent } from 'react';
import { ClassNameProp } from '../common-types';
import { showError, useObjectURL } from '../../lib';

export interface PDFJSPanelProps extends ClassNameProp {
  data: string | Blob;
  onError?: ReactEventHandler<HTMLIFrameElement>;
  onLoad?: (e: SyntheticEvent) => void;
}

/**
 * Display a PDF in an inline pdf.js iframe.
 *
 * PDF.js is loaded from the WebResourceProviderHook, so this will not work in the storybook.
 *
 * TODO: support file url in addition to base64 data??
 * TODO: support easy customization as in the content viewer (hide header, etc.)?
 *
 * @author Bennett Piater
 *
 * @param data of the pdf
 * @param className optional css classes to set in addition to 'pdfjs-iframe'
 * @param onError error callback for exceptions in the iframe, defaults to {@link showError}
 */
export function PDFJsIframe({
  data,
  className,
  onError = showError,
  onLoad
}: PDFJSPanelProps): JSX.Element {
  const objectUrl = useObjectURL(data, 'application/pdf');

  let classes = 'ehs-pdfjs-iframe';
  if (className) classes += ' ' + className;

  return objectUrl ? (
    <iframe
      frameBorder="0"
      allowFullScreen
      className={classes}
      src={'/o/WebResourceProviderHook/pdfjs/web/viewer.html?file=' + objectUrl}
      onError={onError}
      onLoad={onLoad}
    />
  ) : (
    <></>
  );
}
